export default "__VITE_ASSET__BRe94DoY__"